













import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import ReturnVisitPhotoInputDto from '@/store/models/maintain/returnVisitPhotoInput'
@Component({})
export default class UploadPhoto extends VueBase {
	fileList: Array<any> = []
	maintainRecordNO!: any
	returnVisitPhotoInput: ReturnVisitPhotoInputDto = new ReturnVisitPhotoInputDto()
	uploadUrls: Array<string> = []
	isUploadSuccess: boolean = true
	onClickLeft() {
		window.history.go(-1)
	}
	// 上传前置处理
	beforeRead(file: any) {
		return true
	}
	async afterRead(file: any) {
		file.status = 'uploading'
		file.message = '上传中...'
		this.isUploadSuccess = false

		// 大于1MB的图片都缩小像素上传
		if (file.file.size > 1024 * 1024) {
			let canvas = document.createElement('canvas') // 创建Canvas对象(画布)
			let context = canvas.getContext('2d')
			let img = new Image()
			img.src = file.content // 指定图片的DataURL(图片的base64编码数据)
			img.onload = async () => {
				let imgWidth = img.width
				let imgHeight = img.height
				canvas.width = imgWidth
				canvas.height = imgHeight
				context?.drawImage(img, 0, 0, imgWidth, imgHeight)
				file.content = canvas.toDataURL(file.file.type, 0.6) // 0.92为默认压缩质量
				let files = util.dataURLtoFile(file.content, file.file.name)
				await this.postImg(files, file)
			}
		} else { // 小于1M直接上传
			let fd = new FormData()
			fd.append('file', file.file)
			await ajax.post('/PutObject?maintainRecordNO=' + this.maintainRecordNO, fd)
				.then(rep => {
					if (rep.data.code === 1) {
						this.fileList = []
					} else {
						this.isUploadSuccess = true
						this.returnVisitPhotoInput.maintainRecordId = rep.data.result[0].key
						this.uploadUrls.push(rep.data.result[0].url)
						file.status = 'done'
						file.message = '上传成功'
					}
				})
		}
	}
	async postImg(files: any, file: any) {
		let fd = new FormData()
		fd.append('file', files)
		await ajax.post('/PutObject?maintainRecordNO=' + this.maintainRecordNO, fd)
			.then(rep => {
				if (rep.data.code === 1) {
					this.fileList = []
				} else {
					this.isUploadSuccess = true
					this.returnVisitPhotoInput.maintainRecordId = rep.data.result[0].key
					this.uploadUrls.push(rep.data.result[0].url)
					file.status = 'done'
					file.message = '上传成功'
				}
			})
	}
	async submit() {
		if (this.uploadUrls.length === 0) {
			this.$toast.fail('请先上传图片')
			return false
		}
		if (!this.isUploadSuccess) {
			this.$toast.fail('图片上传成功后再提交')
			return false
		}
		this.returnVisitPhotoInput.urls = []
		this.returnVisitPhotoInput.urls.push(...this.uploadUrls)
		await ajax.post('/api/maintainrecord/return-visit-photo-insert', this.returnVisitPhotoInput)
			.then(() => {
				this.$toast.success('上传成功')
				window.history.back()
			})
	}
	created() {
		this.maintainRecordNO = this.$route.query.no
	}
}
